export default "__VITE_ASSET__BRYdlVdO__"